import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CacheSCLSearchConfigCommandModel } from '../models/cache_scl_search_config_command_model';
import { ILoadSclSearchConfigCommand } from './load_scl_search_config_command';

export type IInitiateCachedSclSearchConfigCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-academic-planner')
  .service(
    'initiateCachedSclSearchConfigCommand',
    function initiateCachedSclSearchConfigCommandDefinition(
      defineCommandORM: IDefineCommand,
      loadSclSearchConfigCommand: ILoadSclSearchConfigCommand,
      ngCacheSCLSearchConfigCommandModel: CacheSCLSearchConfigCommandModel,
      $q: ng.IQService
    ) {
      return defineCommandORM('initiateCachedSclSearchConfigCommand', function cachedSclSearchConfigCommand(deferred) {
        const existingRequests = ngCacheSCLSearchConfigCommandModel.read().requests;
        const sclConfig = 'scl-config';
        if (!_4.has(existingRequests, sclConfig)) {
          ngCacheSCLSearchConfigCommandModel.write({
            requests: {
              ...existingRequests,
              [sclConfig]: [loadSclSearchConfigCommand()]
            }
          });
        }
        return $q.all(existingRequests[sclConfig]);
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/commands/cached_scl_search_config_command.ts